var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1999 20.4322H10.7999C10.4499 20.4322 10.1599 20.2322 10.1599 19.9922V14.8022C10.1599 14.6822 10.2299 14.5722 10.3499 14.4922L13.5499 12.3622C13.7999 12.2022 14.1899 12.2022 14.4399 12.3622L17.6399 14.4922C17.7599 14.5722 17.8299 14.6922 17.8299 14.8022V19.9922C17.8399 20.2322 17.5499 20.4322 17.1999 20.4322Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32983 15.1836L13.5398 12.3736C13.8098 12.2036 14.1798 12.2036 14.4398 12.3736L18.6498 15.1736",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0899 23.332H6.90994C6.29994 23.332 5.79994 22.862 5.74994 22.262L4.76994 10.602C4.70994 9.92203 5.24994 9.33203 5.92994 9.33203H22.0599C22.7399 9.33203 23.2799 9.91203 23.2199 10.592L22.2499 22.262C22.2099 22.872 21.6999 23.332 21.0899 23.332Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7H21",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32983 4.67188H18.6698",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListings);
export default __webpack_public_path__ + "static/media/listings.87d58bb5.svg";
export { ForwardRef as ReactComponent };